import endpointVersion from '@/helpers/endpoint-version';
import store from '@/store';
import axios from 'axios';
export const getAllCriteria = () => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    const user = store.getters.user;
    return axios.get('/audience/getColumnsChained', {
        baseURL: endpointVersion('v3'),
        params: {
            locale: user?.language || 'pt-BR',
            brand: brand.id,
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
export const getQuery = audienceId => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/audience/getQuery', {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            audience_id: audienceId,
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
export const getResultByTerm = (criteriaKey, searchText) => {
    const brand = store.getters.selectedBrand;
    const tokenV3 = store.state.auth.tokenV3;
    return axios.get('/audience/getResultsByField', {
        baseURL: endpointVersion('v3'),
        params: {
            brand: brand.id,
            field: criteriaKey,
            term: searchText,
            limit: 100,
            orderby: criteriaKey,
        },
        headers: { Authorization: `Bearer ${tokenV3}` },
    });
};
